import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=50b15c66&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b15c66",
  null
  
)

export default component.exports